import React, { useEffect } from 'react';

import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';
import { CO2Saved, IResDashboard } from '@/types/parcel/dashboard';

import { useDate } from '../Context/DateContext';

interface StateData {
  data: CO2Saved | null;
  loading: boolean;
  error: boolean;
}
const useCO2Deliveries = () => {
  const { selectedDate } = useDate();
  const [data, setData] = React.useState<StateData>({
    data: null,
    loading: true,
    error: false,
  });

  const getCO2Saved = async () => {
    const http = initializeHttpProvider();
    try {
      const response = await http.dashboard.co2Saved(selectedDate);

      setData({
        data: (response as IResDashboard<CO2Saved>).data,
        loading: false,
        error: false,
      });
    } catch {
      setData({ data: null, loading: false, error: true });
    }
  };

  useEffect(() => {
    getCO2Saved();
  }, [selectedDate]);

  return {
    data,
  };
};

export default useCO2Deliveries;
